import { Injectable } from '@angular/core';
import {User} from './user';
import {Observable} from 'rxjs';
import {AngularFireAction, AngularFireDatabase, AngularFireList} from '@angular/fire/database';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {FirebaseListObservable} from '@angular/fire/database-deprecated';
import {promise} from 'selenium-webdriver';
import map = promise.map;

@Injectable()
export class UserService {

  static usersPath = 'users/';

  constructor(private db:AngularFireDatabase) {
  }

  // DONE: upgraded to Firebase 5.0 (beware, no database keys, just the values!)
  findAllUsers():Observable<User[]> {
    return this.db.list('users').valueChanges().map(User.fromJsonArray);
  }

  // DONE: upgraded to Firebase 5.0
  findUserByUid(uid:string): Observable<any> {  // was User
    return this.db.object('/users/' + uid)
      .snapshotChanges()
      .map(action => {
          const $key = action.payload.key;
          return { $key, ...action.payload.val() };
        })
  }

  // DONE: upgrade to Firebase 5.0
  findUsersForClub(clubId: string): Observable<any[]> {
      // console.log("In FindUsersForClub");
      return this.db.list('/users', ref => ref.orderByChild('club').equalTo(clubId))
        .snapshotChanges()
        .map(actions => {
          return actions.map(action => {
            const $key = action.payload.key;
            return { $key, ...action.payload.val() };
          })
        })
        //.do(console.log);
  }

  setLastLoggedIn(uid: string) {
      let displayDate = new Date().toLocaleDateString('nl-NL');
      let displayTime = new Date().toLocaleTimeString('nl-NL');
      let dateTime = displayDate + ' - ' + displayTime;

      return this.db.object('users' + '/' + uid).update({"lastLoggedIn": dateTime});
  }

  updateUser(uid: string, update: Object) {
      this.db.object(UserService.usersPath + uid).update(update);
  }

  deleteUser(uid: string) {
    this.db.object(UserService.usersPath + uid).remove();
  }

  addUserToClub(uid: string, clubId: string, name: string, email: string, phone: string, role: string, intensity: number) {

    let u = {
      "name": name,
      "club": clubId,
      "email": email,
      "phone": phone,
      "role": role,
      "intensity": intensity,
      "lastLoggedIn": "[nieuwe login]"
    };
    this.db.object('users' + '/' + uid).set(u);
  }

}
